import React, {Component} from 'react';
import {show_popup, close_popup, addStepLog, setUrlSinglePageApp} from "../functions";
import {Redirect} from "react-router-dom";
import {withRouter} from "react-router";


class ShowPopup extends Component {
    constructor(props) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        let text = <p>You will find the vehicle's keys in the glovebox or driver’s side door, which you can use to start the vehicle or
            open/lock the vehicle for the duration of your hire.</p>;
        this.state = {content: text};
    }

    nextPage() {
        addStepLog('Press Button GoNext on Keys In the Glovebox popup');
        close_popup();
        this.props.redirectNext();
    }

    render() {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <div className="p-3">
                        {
                            this.state.content
                        }
                        <button type="button"
                                className="go-btn go-next"
                                onClick={this.nextPage}/>
                    </div>
                </div>
            </div>
        )
    }
}



class WhereFindKeysPage extends Component {
    constructor(props) {
        super(props);
        this.state = {redirect: false};

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    componentDidMount() {
        show_popup(<ShowPopup redirectNext={()=>this.setState({redirect: true})}
        />, {auto_close:false})
    }

    render() {
        if (this.state.redirect){
            addStepLog('Check fuel Page');
            return <Redirect push to={"/check_fuel"}/>;
        }

        return (
            <div className={'value-space'}/>
        );
    }
}

const WhereFindKeysPageR = withRouter(WhereFindKeysPage);
export default WhereFindKeysPageR;
